import { useUpdateEntityApi } from '@/common/api/updateEntityApi';
import { useOutboundDeliveryStore } from '../stores/outboundDeliveryStore';
import type { OutboundDeliveryResponse } from './common/outboundDeliveryResponse';
import type { DeliveryStatus } from 'shared/deliveries/domain/deliveryStatus';

export interface UpdateOutboundDelivery {
  id: string;
  name: string;
  note: string | null;
  status: DeliveryStatus;
  customer: string | null;
  customerReference: string | null;
  plannedStartUtc: string | null;
  plannedFinishUtc: string | null;
  rows: UpdateOutboundDeliveryRow[];
}

export interface UpdateOutboundDeliveryRow {
  id?: string;
  productId: string;
  storageAreaId: string | null;
  weight: number | null;
  volume: number | null;
  note: string | null;
}

export interface UpdateOutboundDeliveryResponse {
  ok: true;
  delivery: OutboundDeliveryResponse;
}

export function useUpdateOutboundDeliveryApi() {
  const store = useOutboundDeliveryStore();

  return useUpdateEntityApi<UpdateOutboundDelivery, UpdateOutboundDeliveryResponse>({
    url: 'delivery/outbound',
    translate: (t) => t.outboundDelivery.actions.update,
    async processOk(response) {
      const json = (await response.json()) as OutboundDeliveryResponse;
      store.add(json);
      return {
        ok: true,
        delivery: json,
      };
    },
  });
}
